import App from 'app/app.js';

function LtOrderReceiptChildSummaryCtrl($scope) {
  this.isOpen = true;

  this.hasShipToLocation = function (location) {
    return R.contains(location, $scope.receiptData.shipToLocations);
  };
}

App.controller('LtOrderReceiptChildSummaryCtrl', ['$scope', LtOrderReceiptChildSummaryCtrl]);
